import React from 'react'
import EmailSuccessTemplate from '../../../Templates/Auth/ForgotPassword/EmailSuccess.template'

function EmailSuccessPage() {
  return (
    <EmailSuccessTemplate />
  )
}

export default EmailSuccessPage